import React from "react";
import rootDispatcher from "../../network/rootDispatcher";
import autobind from "../../network/autobind"; // eslint-disable-line no-unused-vars

import "./noti-banner.scss";

export default class NotiBanner extends React.Component {
  constructor(props) {
    super();

    this.state = {
      notifications: {}
    };
  }

  componentWillMount() {
    rootDispatcher.on("NB:OPEN", this.open);
  }

  componentWillUnmount() {
    rootDispatcher.off("NB:OPEN", this.open);
  }

  @autobind
  open({ type, msg, timeout = 5000 }) {
    const { notifications } = this.state;

    // create the notification object
    const key = new Date().getTime() + '/' + Math.random(0, 23423);
    notifications[key] = {
      msg,
      type,
      open: false,
      destroy: false
    };

    this.setState({ notifications });

    // open up the notification
    setTimeout(() => {
      notifications[key].open = true;
      this.setState({ notifications });

      // setup for object destruction
      setTimeout(() => {
        notifications[key].destroy = true;
        this.setState({ notifications });

        // destroy the actual object
        setTimeout(() => {
          delete notifications[key];
          this.setState({ notifications });
        }, 2000);
      }, timeout);
    }, 100);
  }

  render() {
    const { notifications } = this.state;

    const elements = Object.keys(notifications).map((key) => {
      const baseClass = ["noti-banner"];

      baseClass.push(`noti-banner--${notifications[key].type}`);

      if (notifications[key].open) {
        baseClass.push("noti-banner--visible");
      }

      if (notifications[key].destroy) {
        baseClass.push("noti-banner--destroy");
      }

      return (
        <div key={key} className={baseClass.join(" ")}>
          <span className="noti-banner__icon" />
          <span className="noti-banner__message">
            {notifications[key].msg}
            {notifications[key].type === "error" ? (
              <span>
                &nbsp;
                <a
                  className="noti-banner__help"
                  href="https://blackdove.zendesk.com"
                  target="_blank"
                  rel="noopener noreferrer"
                >
                  Get Help
                </a>
              </span>
            ) : null}
          </span>
        </div>
      );
    });

    return <div className="notifications">{elements}</div>;
  }
}
